import { Ref, computed } from '@vue/composition-api';
import { AccountRole, BuyType } from '@tt4b/ttam-enums';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';

export function useInitDataGet(props: { role: Ref<AccountRole> }) {
  const { role } = props;
  return {
    classify: [AccountRole.ROLE_ADMIN, AccountRole.ROLE_INTERNAL_ADV].includes(role.value) ?
      BuyType.PROMOTION :
      BuyType.PURCHASE,
  };
}

export function usePropsVisible() {
  const { state } = useStore();
  return {
    visible: computed(() => state[StateEnum.accountInfo]?.data?.value?.permission?.is_admin),
  };
}
